const n = "Ой, щось пішло не так", o = { unknownError: n };
export {
  o as default,
  n as unknownError
};
//# sourceMappingURL=errors.json.js.map
